<template>
  <div class="provider">
    <SidebarLayout3 :breadcrumb="breadcrumb" :pageTitle="pageTitle">
      <!-- BARRA LATERAL -->
      <template #sidebar>
        <!-- AÇÕES DA PÁGINA -->
        <SidebarBlock class="page-actions">
          <Heading>Ações da página</Heading>
          <!-- CADASTRAR -->
          <Button
            :disabled="checkDisableSave"
            tooltipText="Necessário preencher o Nome, CNPJ, E-mail e CEP."
            class="page-actions--button"
            @click="providerId === null ? saveProvider() : editProvider()"
          >
            Salvar
          </Button>
          <!-- LISTAGEM DE GRUPO DE USUÁRIOS -->
          <Button
            link="/fornecedores"
            element="router-link"
            class="page-actions--button"
            layout="outline"
          >
            Voltar sem salvar
          </Button>
          <!-- EXCLUIR -->
          <Button
            v-if="providerId !== null && status"
            variation="error"
            class="page-actions--button"
            @click="showConfirmationInactiveModal = true"
          >
            Desativar
          </Button>
          <!-- ATIVAR -->
          <Button
            v-if="providerId !== null && !status"
            class="page-actions--button"
            @click="activeProvider()"
          >
            Reativar
          </Button>
        </SidebarBlock>
      </template>
      <!-- CONTEÚDO -->
      <template #content class="form">
        <Heading class="form--heading form--heading__primary" level="2">
          Informações gerais do fornecedor
        </Heading>

        <div class="form--row form--row__primary">
          <!-- NOME -->
          <FormInput
            v-model="form.nome"
            :required="true"
            :infoIcon="true"
            infoText="Nome fantasia ou razão social do fornecedor. Esta informação não será exibida no site público."
            tooltipMinWidth="195"
            label="Nome"
            placeholder="Insira o nome do fornecedor"
            class="form--input__name"
            data-cy="input-name"
          />
          <!-- CNPJ -->
          <div class="form--input__cnpj">
            <CnpjInput
              :value="form.cnpj"
              :error="!form.cnpj && showErrors"
              label="CNPJ"
              data-cy="input-cnpj"
              @input="form.cnpj = $event"
            />
          </div>
        </div>

        <!-- STATUS DO FORNECEDOR  -->
        <div v-if="!status">
          <Paragraph>Esse fornecedor está inativo.</Paragraph>
          <span class="form--link" @click="activeProvider()">
            Clique aqui para reativar.
          </span>
        </div>

        <SeparateLine :top="40" :left="0" :right="0" :bottom="30" />

        <Heading class="form--heading" level="2">
          Contato
        </Heading>

        <!-- E-MAIL -->
        <FormInput
          v-model="form.email"
          :required="true"
          type="email"
          label="E-mail"
          placeholder="Insira o email"
          class="form--input__email"
          data-cy="input-email"
        />

        <div class="form--row form--row__phone">
          <!-- DDD -->
          <div class="form--input__ddd form--mask">
            <label for="ddd1">
              <strong>DDD</strong>
            </label>
            <the-mask
              v-model="form.telefone1.ddd"
              :masked="true"
              :mask="'(##)'"
              placeholder="(00)"
              type="text"
              id="ddd2"
              data-cy="input-ddd-1"
            >
            </the-mask>
          </div>
          <!-- TELEFONE -->
          <div class="form--input__telefone form--mask">
            <label for="telefone1">
              <strong>Telefone</strong>
            </label>
            <the-mask
              v-model="form.telefone1.numero"
              :masked="true"
              :mask="['# ####-####', '####-####']"
              placeholder="0 0000-0000"
              type="text"
              id="telefone1"
              data-cy="input-phone-1"
            >
            </the-mask>
          </div>
          <!-- ADICIONAR TELEFONE -->
          <Button
            v-if="!showTelefone2"
            :hasIcon="true"
            size="large"
            layout="outline"
            data-cy="add-phone-2"
            @click="showTelefone2 = !showTelefone2"
          >
            Adicionar telefone
          </Button>
        </div>

        <div v-if="showTelefone2" class="form--row form--row__phone">
          <!-- DDD -->
          <div class="form--input__ddd form--mask">
            <label for="ddd2">
              <strong>DDD 2</strong>
            </label>
            <the-mask
              v-model="form.telefone2.ddd"
              :masked="true"
              :mask="'(##)'"
              placeholder="(00)"
              type="text"
              id="ddd2"
              data-cy="input-ddd-2"
            >
            </the-mask>
          </div>
          <!-- TELEFONE -->
          <div class="form--input__telefone form--mask">
            <label for="telefone2">
              <strong>Telefone 2</strong>
            </label>
            <the-mask
              v-model="form.telefone2.numero"
              :masked="true"
              :mask="['# ####-####', '####-####']"
              placeholder="0 0000-0000"
              type="text"
              id="telefone2"
              data-cy="input-phone-2"
            >
            </the-mask>
          </div>
          <!-- REMOVER TELEFONE 2 -->
          <Button
            :hasIcon="true"
            variation="error"
            size="large"
            layout="outline"
            class="form--button__error"
            @click="removeTelefone()"
          >
            <template #icon>
              <Icon icon="x-icon" />
            </template>
            <template>Remover telefone</template>
          </Button>
        </div>

        <SeparateLine :top="40" :left="0" :right="0" :bottom="30" />

        <Heading class="form--heading" level="2">
          Endereço
        </Heading>

        <!-- CEP -->
        <div class="form--input__cep form--mask">
          <label for="cep">
            <strong>CEP</strong>
            <span class="form--asterisk">*</span>
          </label>
          <the-mask
            v-model="form.cep"
            :masked="true"
            placeholder="Insira o CEP"
            mask="#####-###"
            type="text"
            id="cep"
            data-cy="input-cep"
            @input="cep()"
          >
          </the-mask>
        </div>

        <div class="form--row form--row__address">
          <div class="form--row__item">
            <!-- LOGRADOURO -->
            <FormInput
              v-model="form.rua"
              :readonly="true"
              label="Logradouro"
              placeholder="Insira o logradouro"
              class="form--input__logradouro"
            />
          </div>
          <div class="form--row__item">
            <!-- NÚMERO -->
            <FormInput
              v-model="form.numero"
              type="number"
              label="Número"
              placeholder="Insira o número"
              class="form--input__numero"
              data-cy="input-number"
            />
            <!-- COMPLEMENTO -->
            <FormInput
              v-model="form.complemento"
              label="Complemento"
              placeholder="Insira um complemento"
              class="form--input__complemento"
            />
          </div>
        </div>
        <div class="form--row form--row__address">
          <div class="form--row__item">
            <!-- BAIRRO -->
            <FormInput
              v-model="form.bairro"
              :readonly="true"
              label="Bairro"
              placeholder="Insira o bairro"
              class="form--input__bairro"
            />
          </div>
          <div class="form--row__item">
            <!-- CIDADE -->
            <FormInput
              v-model="form.cidade"
              :readonly="true"
              label="Cidade"
              placeholder="Insira a cidade"
              class="form--input__cidade"
            />
            <!-- ESTADO -->
            <FormInput
              v-model="form.uf"
              :readonly="true"
              label="Estado"
              placeholder="Insira o estado"
              class="form--input__estado"
            />
          </div>
        </div>

        <SeparateLine :top="40" :left="0" :right="0" :bottom="30" />

        <Heading class="form--heading form--heading__with-subtitle" level="2">
          Hotéis atendidos pelo fornecedor
        </Heading>
        <Paragraph class="form--subtitle">
          Selecione os hotéis atendidos por esse fornecedor.
        </Paragraph>

        <!-- HOTEIS -->
        <FormSelect
          v-model="form.hoteis"
          :options="hotels"
          :multiple="true"
          :search="true"
          :infoIcon="true"
          :toggleAllLabel="'Todos'"
          infoText="Hotéis selecionados para este fornecedor. Caso nenhum esteja selecionado, serão considerados todos."
          tooltipMinWidth="179"
          label="Selecione os hotéis"
          placeholder="Todos"
          class="form--input__hotels"
          data-cy="select-hotel"
        />

        <SeparateLine :top="40" :left="0" :right="0" :bottom="30" />

        <!-- DADOS DE REGISTRO -->
        <div v-if="providerId" class="form--register">
          <div class="form--register__item">
            <Heading level="3">
              Registrado por
            </Heading>
            <Paragraph>
              {{ logs.created.name }}<br />{{ logs.created.date }}
            </Paragraph>
          </div>
          <div v-if="logs.updated.name" class="form--register__item">
            <Heading level="3">
              Alterado por
            </Heading>
            <Paragraph>
              {{ logs.updated.name }}<br />{{ logs.updated.date }}
            </Paragraph>
          </div>
        </div>

        <SeparateLine
          v-if="providerId"
          :top="40"
          :left="0"
          :right="0"
          :bottom="30"
        />

        <!-- AÇÕES -->
        <div class="form--actions">
          <!-- CANCELAR -->
          <Button
            :link="`/fornecedores`"
            element="router-link"
            layout="outline"
            size="large"
          >
            Voltar sem salvar
          </Button>
          <!-- SALVAR -->
          <Button
            :disabled="checkDisableSave"
            tooltipText="Necessário preencher o Nome, CNPJ, E-mail e CEP."
            popperPosition="top"
            tooltipMinWidth="230"
            popperStrategy="absolute"
            size="large"
            data-cy="save-provider"
            @click="providerId === null ? saveProvider() : editProvider()"
          >
            Salvar
          </Button>
        </div>
      </template>
    </SidebarLayout3>
    <!-- MODAL - EXCLUIR FORNECEDOR -->
    <AlertModal
      v-model="showConfirmationInactiveModal"
      title="Desativar fornecedor"
      @alert-modal-confirm="inativeProvider"
      @alert-modal-cancel="cancelInativeProvider"
    >
      <template #text>
        Ao desativar, esse fornecedor não estará mais <br />
        disponível para vínculo com novos produtos. <br />
        Tem certeza que quer fazer isso?
      </template>
    </AlertModal>
    <!-- MODAL - ATENÇÃO -->
    <AlertModal
      v-model="showAlertModal"
      icon="alert"
      sizeIcon="large"
      confirmButtonText="Ok, entendi"
      cancelButtonText="Cancelar"
      title="Atenção"
      @alert-modal-confirm="showAlertModal = false"
      @alert-modal-cancel="showAlertModal = false"
    >
      <template #text>
        Não é possível desativar, pois esse fornecedor <br />
        está vinculado a um produto ativo. Para <br />
        desativar, é necessário desvincula-lo do produto.
      </template>
    </AlertModal>
  </div>
</template>

<script>
import SidebarLayout3 from '@/layouts/SidebarLayout3'
import SidebarBlock from '@solucoes/components-lib-tmp/src/components/patterns/SidebarBlock'
import Heading from '@solucoes/components-lib-tmp/src/components/elements/Heading'
import Button from '@solucoes/components-lib-tmp/src/components/elements/Button'
import Icon from '@solucoes/components-lib-tmp/src/components/elements/Icon'
import FormInput from '@solucoes/components-lib-tmp/src/components/elements/FormInput'
import AlertModal from '@solucoes/components-lib-tmp/src/components/patterns/AlertModal'
import Paragraph from '@solucoes/components-lib-tmp/src/components/elements/Paragraph'
import SeparateLine from '@solucoes/components-lib-tmp/src/components/elements/SeparateLine'
import FormSelect from '@solucoes/components-lib-tmp/src/components/elements/FormSelect'
import { TheMask } from 'vue-the-mask'
import { formatDate } from '@/helpers/date'
import { removeSpecialCharacteres, isEmpty } from '@/helpers/string'
import CnpjInput from '@/components/_base/patterns/CnpjInput'

export default {
  name: 'CreateProvider',
  components: {
    SidebarLayout3,
    SidebarBlock,
    Heading,
    Button,
    Icon,
    FormInput,
    AlertModal,
    Paragraph,
    SeparateLine,
    FormSelect,
    TheMask,
    CnpjInput
  },
  data() {
    return {
      breadcrumb: [
        {
          label: 'Configurações',
          url: '',
          isSpa: false /** se deve ser um link para o site novo ou antigo  */
        },
        {
          label: 'Fornecedores',
          url: '/fornecedores',
          isSpa: true /** se deve ser um link para o site novo ou antigo  */
        },
        {
          label: 'Criar novo fornecedor',
          url: '/fornecedores/criar',
          isSpa: true /** se deve ser um link para o site novo ou antigo  */
        }
      ],
      providerId: null,
      pageTitle: 'Criar novo fornecedor',
      /** Dados para o formmulário */
      form: {
        ativo: true,
        nome: null,
        cnpj: '',
        cep: null,
        rua: null,
        bairro: null,
        cidade: null,
        uf: null,
        numero: null,
        complemento: null,
        email: null,
        telefone1: {
          ddd: '',
          numero: ''
        },
        telefone2: {
          ddd: '',
          numero: ''
        },
        hoteis: []
      },
      /** Status do fornecedor */
      status: true,
      /** Mostrar modal de confirmação de remoção */
      showConfirmationInactiveModal: false,
      /** Mostrar modal de alerta */
      showAlertModal: false,
      /** Estados */
      states: [],
      /** Hoteis */
      hotels: [],
      /** Mostrar campos do segundo telefone */
      showTelefone2: false,
      /** Dados dos logs */
      logs: {
        created: {
          name: null,
          date: null
        },
        updated: {
          name: null,
          date: null
        }
      }
    }
  },
  computed: {
    /** Habilitar/desabilitar o botão "Salvar" */
    checkDisableSave() {
      const name = this.form.nome
      const cnpj = this.form.cnpj
      const cep = this.form.cep
      const email = this.form.email

      return name && cnpj && cep && email ? false : true
    }
  },
  async created() {
    /** Se for edição, pegar o ID e o fornecedor */
    this.providerId = this.$route.params.id || null
    /** Buscar os hoteis e o fornecedor*/
    await this.getHotels()
    await this.getProvider()
  },
  methods: {
    /** Se for edição, buscar fornecedor */
    async getProvider() {
      if (this.providerId !== null) {
        await this.$provider
          .get(this.providerId)
          .then((response) => {
            /** Pegar dados */
            this.form.ativo = response.data.ativo
            this.form.nome = response.data.nome
            this.form.cnpj = response.data.cnpj
            this.form.cep = response.data.cep
            this.form.rua = response.data.rua
            this.form.bairro = response.data.bairro
            this.form.cidade = response.data.cidade
            this.form.uf = response.data.uf
            this.form.numero = response.data.numero
            this.form.complemento = response.data.complemento
            this.form.email = response.data.email
            this.form.telefone1 = response.data.telefone1
            this.form.telefone2 = response.data.telefone2

            /** Pegar os IDS do hoteis do fornecedor */
            const idHotels = response.data.hoteis.map((i) => i.codigo)
            this.form.hoteis = this.hotels.filter((item) =>
              idHotels.includes(item.value)
            )

            /** Logs */
            this.logs.created.name = response.data.usuarioCadastro
            this.logs.created.date = formatDate(
              new Date(response.data.dataCadastro),
              'dd/MM/yyyy HH:mm:ss'
            )
            this.logs.updated.name = response.data.usuarioAlteracao
            this.logs.updated.date = formatDate(
              new Date(response.data.dataAlteracao),
              'dd/MM/yyyy HH:mm:ss'
            )

            /** Atualizar o status do fornecedor */
            this.status = response.data.ativo

            /** Verificar se tem telefone 2 */
            this.showTelefone2 = response.data.telefone2.numero ? true : false

            /** Alterar breadcrump */
            this.pageTitle = `Editando ${response.data.nome}`
            this.breadcrumb[
              this.breadcrumb.length - 1
            ].label = `Editando ${response.data.nome}`
          })
          .catch(() => {
            this.$bus.$emit('show-alert-chip', {
              message: 'Houve um erro ao buscar o fornecedor'
            })
            /** Redirecionar para a listagem de fornecedor */
            setTimeout(() => {
              this.$router.push({
                path: '/fornecedores'
              })
            }, 1000)
          })
      }
    },

    /** Buscar hoteis */
    async getHotels() {
      await this.$hotel
        .get()
        .then((response) => {
          this.hotels = this.formatHotels(response.data)
        })
        .catch(() => {
          this.$bus.$emit('show-alert-chip', {
            message: 'Houve um erro ao buscar os hoteis'
          })
        })
    },

    /** Salvar fornecedor */
    saveProvider() {
      /** Pegar dados do fornecedor */
      const data = this.buildDataProvider()
      this.$provider
        .create(data)
        .then(() => {
          /** Feedback de sucesso */
          this.$bus.$emit('show-alert-chip', {
            message: 'Fornecedor criado com sucesso!'
          })
          /** Redirecionar para a listagem de grupos de usuários */
          setTimeout(() => {
            this.$router.push({
              path: '/fornecedores'
            })
          }, 1000)
        })
        .catch((error) => {
          this.$bus.$emit('show-alert-chip', {
            message: error.messages
          })
        })
    },

    /** Editar fornecedor */
    editProvider() {
      /** Pegar dados do fornecedor */
      const data = this.buildDataProvider()
      this.$provider
        .edit({ codigo: parseInt(this.providerId), ...data })
        .then(() => {
          /** Feedback de sucesso */
          this.$bus.$emit('show-alert-chip', {
            message: 'Fornecedor editado com sucesso!'
          })
          /** Redirecionar para a listagem de grupos de usuários */
          setTimeout(() => {
            this.$router.push({
              path: '/fornecedores'
            })
          }, 1000)
        })
        .catch((error) => {
          this.$bus.$emit('show-alert-chip', {
            message: error.messages
          })
        })
    },

    /** Montar dados para o endoint */
    buildDataProvider() {
      const dataProvider = {
        nome: this.form.nome,
        cnpj: removeSpecialCharacteres(this.form.cnpj),
        ativo: this.form.ativo,
        cep: removeSpecialCharacteres(this.form.cep),
        rua: this.form.rua,
        bairro: this.form.bairro,
        cidade: this.form.cidade,
        uf: this.form.uf,
        numero: this.form.numero,
        complemento: this.form.complemento,
        email: this.form.email,
        telefone1: {
          ddd: removeSpecialCharacteres(this.form.telefone1.ddd),
          numero: removeSpecialCharacteres(this.form.telefone1.numero)
        },
        telefone2: {
          ddd: removeSpecialCharacteres(this.form.telefone2.ddd),
          numero: removeSpecialCharacteres(this.form.telefone2.numero)
        },
        hoteis:
          this.form.hoteis && this.form.hoteis.length > 0
            ? this.form.hoteis.map((a) => a.value)
            : this.hotels.map((a) => a.value)
      }
      /** Se não houver dados do telefone1 */
      if (
        isEmpty(dataProvider.telefone1.ddd) &&
        isEmpty(dataProvider.telefone1.numero)
      ) {
        delete dataProvider.telefone1
      }
      /** Se não houver dados do telefone2 */
      if (
        isEmpty(dataProvider.telefone2.ddd) &&
        isEmpty(dataProvider.telefone2.numero)
      ) {
        delete dataProvider.telefone2
      }
      return dataProvider
    },

    /** Ativar fornecedor */
    activeProvider() {
      this.form.ativo = true
      this.editProvider()
    },

    /** Inativar fornecedor */
    inativeProvider() {
      const fornecedores = [this.providerId]
      this.$provider
        .delete(fornecedores)
        .then(() => {
          /** Feedback */
          this.$bus.$emit('show-alert-chip', {
            message: 'Fornecedor desativado com sucesso.'
          })
          /** Redirecionar para a listagem de grupos de usuários */
          setTimeout(() => {
            this.$router.push({
              path: '/fornecedores'
            })
          }, 1000)
        })
        .catch(() => {
          /** Mostrar modal de alerta */
          this.showAlertModal = true
        })
    },

    /** Cancelar inativação dos fornecedor */
    cancelInativeProvider() {
      this.showConfirmationInactiveModal = false
    },

    /** Pegar os dados do endereço através do CEP */
    async cep() {
      if (this.form.cep.length === 9) {
        const response = await this.$zipCode.get(this.form.cep)
        /** Distribuir dados */
        this.form.bairro = response.data ? response.data.bairro : null
        this.form.rua = response.data ? response.data.logradouro : null
        this.form.uf = response.data ? response.data.uf : null
        this.form.cidade = response.data ? response.data.localidade : null
      }
    },

    /** Formatar hoteis */
    formatHotels(hotels) {
      return hotels.map((item) => {
        return {
          value: item.codigo,
          text: item.nome
        }
      })
    },

    /** Remover telefone */
    removeTelefone() {
      this.showTelefone2 = false
      this.form.telefone2 = {
        ddd: null,
        numero: null
      }
    }
  }
}
</script>

<style lang="scss" scoped>
::v-deep .lb-breadcrumb--link:nth-child(2) {
  cursor: default;
}
.page-actions {
  .heading {
    margin-bottom: 30px;
  }
  &--button {
    width: 100%;
    cursor: pointer;

    & + .page-actions--button {
      margin-top: 10px;
    }
  }
}

.form {
  &--heading {
    color: $pmw-gray-darkest;
    font-weight: 300;
    margin-bottom: 20px;

    &__primary {
      margin-bottom: 40px;
    }

    &__with-subtitle {
      margin-bottom: 5px;
    }
  }

  &--subtitle {
    line-height: 18px;
    font-size: font-size('size-small');
    color: $pmw-gray-dark;
    margin-bottom: 30px;
  }

  &--input {
    box-shadow: 0 0 0 30px white inset !important;

    &__name {
      max-width: 276px;
    }

    &__cnpj {
      max-width: 262px;
      width: 100%;
    }

    &__ddd {
      max-width: 80px;
    }

    &__email {
      max-width: 276px;
      margin-bottom: 30px;
    }

    &__telefone {
      width: 100%;
      max-width: 177px;
    }

    &__ddd {
      width: 100%;
      max-width: 80px;
    }

    &__phone {
      width: 100%;
      max-width: 177px;
    }

    &__cep {
      max-width: 224px;
      margin-bottom: 20px;
    }

    &__numero {
      max-width: 107px;
    }

    &__estado {
      max-width: 162px;
    }

    &__hotels {
      max-width: 320px;
    }
  }

  &--asterisk {
    color: $pmw-error;
    margin-left: 3px;
  }

  &--mask {
    label {
      display: inline-flex;
      align-items: center;
      margin: 0;
      font-size: font-size('size-medium');
      font-weight: 500;
    }

    input {
      display: block;
      height: 40px;
      padding: 1px 0;
      line-height: 21px;
      width: 100%;
      border: none;
      border-bottom: 1px solid $gray-darkest;
      font-size: font-size('size-medium');
      font-weight: 400;
      box-shadow: 0 0 0 30px white inset !important;

      &::placeholder {
        color: $gray-mid;
        font-size: font-size('size-medium');
        font-weight: font-weight('weight-thin');
      }
    }
  }

  &--link {
    font-size: font-size('size-medium');
    color: $pmw-blue;
    text-decoration: underline;
    margin-top: 5px;
    display: block;
    line-height: 21px;
    cursor: pointer;
  }

  &--button {
    &__error {
      ::v-deep button {
        border: none !important;
        filter: none !important;
      }
    }
  }

  &--actions {
    display: flex;
    align-items: center;
    justify-content: space-between;
  }

  &--row {
    display: flex;
    align-items: baseline;
    gap: 20px;
    margin-bottom: 20px;
    width: 100%;

    &__address {
      max-width: 763px;

      & > div:first-of-type {
        max-width: 311px;
      }
    }

    &__phone {
      align-items: flex-end;
      gap: 15px;

      &:last-of-type {
        margin-bottom: 0px;
      }
    }

    &__primary {
      margin-bottom: 30px;
    }

    &__item {
      display: flex;
      align-items: flex-end;
      gap: 20px;
      width: 100%;
    }
  }

  &--register {
    display: flex;
    align-items: center;
    gap: 20px;

    .heading {
      font-size: font-size('size-medium');
      color: $pmw-gray-dark;
      line-height: 21px;
      margin-bottom: 10px;
    }

    .paragraph {
      font-size: font-size('size-small');
      color: $pmw-gray-dark;
      line-height: 18px;
      font-weight: 100;
    }
  }
}

.form-field {
  ::v-deep {
    input {
      box-shadow: 0 0 0 30px white inset !important;
    }
    .input--clear {
      display: none;
    }
  }
}
</style>
